import { styled } from '../jss-style';
import listStyle from './list';

const useListStyle = styled(listStyle, 'list');
export { listStyle, useListStyle };
export default useListStyle;
